export {
  default as RemoveFromGroupsButton,
  RemoveFromGroupsButtonWithHOC,
} from './remove-from-groups-button';
